import React from 'react';
import { capitalize } from 'lodash';
import styled from '@emotion/styled';
import { Text } from '@atlaskit/primitives';
import { getChargeElementV2, ChargeElementType } from '@css-xp/ppc-utils';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';

type UsageProps = {
  activeUsers?: Maybe<number> | Maybe<string>;
  userTier?: Maybe<number>;
  productId?: Maybe<string>;
  edition?: Maybe<string>;
  chargeElement?: Maybe<string>;
};

const UsageContainer = styled.div`
  display: flex !important; // not used stack component here as in some places it is being overridden by block
  flex-direction: column;
`;

export const Usage = ({ activeUsers, userTier, productId, edition, chargeElement }: UsageProps) => {
  return (
    <UsageContainer data-testid="usage-container">
      <Text>
        {activeUsers ?? 0} {userTier ? `/ ${userTier}` : ''}
      </Text>
      <Text color="color.text.subtlest" size="small">
        {capitalize(
          getChargeElementV2({
            productId: productId as string,
            labelPlural: true,
            edition: edition as string,
            chargeElement: chargeElement ?? ChargeElementType.USER,
          })
        )}
      </Text>
    </UsageContainer>
  );
};
